const FALLBACK_LANG = 'en-us';

const AVAILABLE_LOCALES = [
  'ar',
  'cs',
  'da',
  'de',
  'en-us',
  'es-es',
  'fr',
  'he',
  'it',
  'ja',
  'ko',
  'ms',
  'no',
  'pt-br',
  'pt-pt',
  'ru',
  'sv-se',
  'zh-cn',
  'zh-tw',
];

export const resolveImageLocale = (resolvedLanguage: string = FALLBACK_LANG): string => {
  const locale = resolvedLanguage.toLowerCase().replaceAll('_', '-');
  const normalized = locale === 'en' ? FALLBACK_LANG : locale;

  return AVAILABLE_LOCALES.includes(normalized) ? normalized : FALLBACK_LANG;
};
